import React, {useState} from 'react'
import {useDispatch} from 'react-redux'


import {useInputChange} from 'hooks/useInputChange'

import {CONTACTS} from 'constants/contacts'
import {ROUTS} from 'routs/routs'

import {InputEmail} from 'components/UI/InputEmail/InputEmail'
import {Button} from 'components/UI/Button/Button'

import {CheckCircleIcon} from '@heroicons/react/outline'
import Logo from 'images/logo/era-logo.svg'
import {forgotPasswordSagaAC} from 'model/system/systemActionCreators'
import {Trans} from "@lingui/macro";




export const ForgotPasswordContainer: React.FC = () => {

    enum TYPE {
        FORM='form',
        SUCCESS_MESSAGE='success_message',
        ERROR_MESSAGE='error_message'
    }

    const dispatch = useDispatch()

    // URL of paths
    const urlLinkSupport: string = `mailto:${CONTACTS.SUPPORT_EMAIL}`
    const urlHomePage: string = ROUTS.HOME_PAGE

    // Initial fom values
    const {value: emailValue, changeValueHandler: emailChangeValueHandler} = useInputChange('')

    const [forgotPasswordContent, setForgotPasswordContent] = useState(TYPE.FORM)

    const onSubmitHandler = (e:React.FormEvent) => {
        e.preventDefault()
        // TODO: Sent data to server
        dispatch(forgotPasswordSagaAC(emailValue))
        setForgotPasswordContent(TYPE.SUCCESS_MESSAGE)
    }

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <img
                    className="mx-auto h-12 w-auto"
                    src={Logo}
                    alt="Workflow"
                />
                <h2 className="mt-3 text-center text-3xl font-extrabold text-gray-900">
                    <Trans>Recover my password</Trans>
                </h2>
                <p className="mt-2 text-center text-sm text-gray-600">
                    <Trans
                        values={{ urlLinkSupport }}
                    >
                        If you can't to log in, <a href={urlLinkSupport} className="font-medium text-indigo-600 hover:text-indigo-500">contact support</a>
                    </Trans>
                </p>
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="relative bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">

                    {forgotPasswordContent === TYPE.FORM
                        ? <form className="space-y-6" action={urlHomePage} onSubmit={onSubmitHandler} method="POST">

                            <div>
                                <InputEmail
                                    id="email"
                                    name="email"
                                    required={true}
                                    value={emailValue}
                                    label={<Trans>Email</Trans>}
                                    onChange={emailChangeValueHandler}
                                />
                            </div>

                            <div>
                                <Button
                                    type="submit"
                                    label={<Trans>Sign in</Trans>}
                                    buttonClassName="w-full"
                                />
                            </div>

                        </form>
                        : null
                    }

                    {forgotPasswordContent === TYPE.SUCCESS_MESSAGE
                        ? <div className="flex flex-col justify-center gap-4 items-center">
                            <CheckCircleIcon className="h-10 w-10 text-green-500"/>
                            <Trans>
                                <p>Your password recovery request has been received. We sent the e-mail to <span className="font-medium">{emailValue}</span> with further instructions.</p>
                                <p>If you didn’t receive the email, please try again or contact <a href={urlLinkSupport} className="font-medium text-indigo-600 hover:text-indigo-500">support</a>.</p>
                            </Trans>
                        </div>
                        : null
                    }

                    {/* TODO: server error */}

                </div>
            </div>
        </div>
    )
}
